import { computed, inject, Injectable, signal } from '@angular/core';
import { Pipeline } from '@features/audience/pipelines/pipelines.types';
import { PipelinesHttpService } from '@features/audience/pipelines/services/pipelines-http.service';
import { ServiceStateBase } from '@shared/services/service-state-base.types';
import { defer, of } from 'rxjs';
import { catchError, finalize, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PipelineStageSelectorService extends ServiceStateBase {
    private readonly pipelineHttpS = inject(PipelinesHttpService);

    private readonly _pipelines = signal<Pipeline[]>([]);

    readonly pipelines = this._pipelines.asReadonly();
    readonly pipeline = computed(() => this._pipelines().at(0));
    readonly pipelineStages = computed(() => this.pipeline()?.stages ?? []);

    getTHEpipeline() {
        return this.pipeline();
    }

    /** ONLY TO BE USED BY RESOLVER */
    reqPipeline() {
        return defer(() => {
            this.isLoading.set(true);
            return this.pipelineHttpS.getAll$().pipe(
                catchError(() => of({ data: [], total: 0, offset: 0, limit: 0 })),
                map(({ data }) => data),
                tap(pipelines => this._pipelines.set(pipelines)),
                map(pipelines => pipelines.at(0)),
                finalize(() => this.isLoading.set(false))
            );
        });
    }

    /** ONLY TO BE USED ON LOGOUT */
    resetState() {
        this._pipelines.set([]);
    }
}
